<div class="sticky-top mat-elevation-z6 equipment-menu">
    <mat-toolbar class="commodity-header-bar bds-toolbar-blue">
        <mat-toolbar-row style="display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap;">
            <div style="flex: 1 1 auto; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                <span>
                    Acknowledge {{ hotLists?.length }} Hot List{{ hotLists?.length > 1 ? 's' : '' }}
                </span>
                <span *ngIf="isSaving">
                    <small>
                        (saving...)
                        <fa-icon [icon]="iconSpinner" [spin]="true"></fa-icon>
                    </small>
                </span>
            </div>
            <div style="flex: 0 0 auto; white-space: nowrap; display: flex; align-items: center; gap: 8px;">
                <ng-content></ng-content>
                <button
                    mat-stroked-button
                    (click)="saveChanges(hotListForm.form)"
                    [disabled]="isSaving"
                >
                    <fa-icon [icon]="iconSave"> </fa-icon>
                    Update {{ hotLists?.length }} Hot List{{ hotLists?.length > 1 ? 's' : '' }}
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<bds-hotlist-form #hotListForm [hotLists]="hotLists" action="acknowledge"></bds-hotlist-form>
